import sha224 from 'crypto-js/sha224'

export default async function generateSHA224Hash(input) {
  return sha224(input).toString()
}
